<template>
  <div class="row">
    <div class="col-md-12">
      <SelectsV2
        :callbackOnChangeEquipe="onChangeEquipe"
        :activeOptionSemEquipe="false"
        :activeSelectProfissionais="false"
        :activeSelectMicroArea="true"
        :callbackOnChangeMicroArea="onChangeMicroArea"
      />
    </div>
    <div class="col-md-12">
      <b-tabs
        id="tabs-1"
        key="tabs-1"
        fill
        class="esus-feedback-tabs tabs-auto"
        v-model="tabsActive"
      >
        <b-tab title="Lista" active>
          <template v-slot:title> <i class="icofont-list"></i> Lista </template>
          <div>
            <div class="info-table py-4">
              <div class="info-table-item">
                <Subtitle
                  @exibirVermelhos="handleExibirVermelhos"
                  @exibirVerdes="handleExibirVerdes"
                  :setRed="setRed"
                ></Subtitle>
              </div>
              <div class="info-table-item">
                <download-files
                  :callback-pdf="generatePdf"
                  :data="displayedCadastros"
                  :fields="dataFields"
                  name="acompanhamento"
                >
                </download-files>
              </div>
            </div>
            <tabela-cadastros
              ref="table"
              :cadastros="displayedCadastros"
              :loading="loading"
              @filterSearch="filterSearch($event)"
            ></tabela-cadastros>
          </div>
        </b-tab>
        <b-tab title="Percentual">
          <template v-slot:title>
            <i class="icofont-mathematical-alt-1"></i> Percentual
          </template>
          <div class="row mt-4">
            <div class="col-lg-5">
              <vue-select
                name="tipo-acompanhamento"
                v-model="tipoAcompanhamentoConsolidado"
                class="select-tipo-acompanhamento"
                :clearable="false"
                :options="optionsTipoAcompanhamentoConsolidado"
                label="label"
                placeholder="Tipo acompanhamento"
                @input="onChangeTipoAcompanhamentoConsolidado"
              >
                <template slot="option" slot-scope="option">
                  {{ option.label }}
                </template>
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>
          </div>
          <tabela-resultado
            :loading="loading"
            :municipio="dadosDoResultadoMunicipio"
            :equipe="dadosDoResultadoEquipe"
            :micro_area="dadosDoResultadoMicroArea"
            :selectedEquipe="equipe"
            :selectedMicroArea="micro_area"
          >
          </tabela-resultado>
          <grafico-resultado
            :equipe="equipe"
            :micro_area="micro_area"
            :dadosSerieHistorica="dadosSerieHistorica"
            ref="graficoResultado"
          ></grafico-resultado>
        </b-tab>
        <b-tab title="Escore">
          <template v-slot:title>
            <i class="icofont-chart-histogram"></i> Escore
          </template>
          <div class="row mt-4">
            <div class="col-lg-6">
              <vue-select
                name="tipo-acompanhamento"
                v-model="tipoAcompanhamentoClassificacao"
                class="select-tipo-acompanhamento"
                :clearable="false"
                :options="optionsTipoAcompanhamentoClassificacao"
                label="label"
                placeholder="Tipo acompanhamento"
                @input="onChangeTipoAcompanhamentoClassificacao"
              >
                <template slot="option" slot-scope="option">
                  {{ option.label }}
                </template>
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>
          </div>
          <tabela-classificacao
            :equipe="equipe"
            :micro_area="micro_area"
            :dadosDoMunicipio="dadosMunicipioClassificacao"
            :dadosDaEquipe="dadosEquipeClassificacao"
            :dadosDaMicroArea="dadosMicroAreaClassificacao"
            :selectedIndicador="tipoAcompanhamentoClassificacao"
          >
          </tabela-classificacao>
          <div>
            <grafico-classificacao
              :equipe="equipe"
              :micro_area="micro_area"
              :dadosSerieHistorica="dadosSerieHistorica"
              ref="graficoClassificacao"
            ></grafico-classificacao>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Subtitle from './Subtitle'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import VueApexCharts from 'vue-apexcharts'
import * as Functions from './functions.js'
import * as Filter from './filter.js'
import {
  chartOptions,
  dataFields,
  groupFilterItems,
  optionsTipoAcompanhamentoConsolidado,
  optionsTipoAcompanhamentoClassificacao,
} from './utils.js'
import utils from '@/mixins/utils.js'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import TitleTag from '@/components/TitleTag.vue'
import TabelaCadastros from './TabelaCadastros.vue'
import SelectsV2 from '@/components/utils/SelectsV2.vue'
import TabelaResultado from './TabelaResultado.vue'
import GraficoResultado from './GraficoResultado.vue'
import GraficoClassificacao from './GraficoClassificacao.vue'
import TabelaClassificacao from './TabelaClassificacao.vue'

export default {
  name: 'AcompanhamentoPorEquipeAcs',
  components: {
    Subtitle,
    apexchart: VueApexCharts,
    DownloadFiles,
    TitleTag,
    PulseLoader,
    TabelaCadastros,
    SelectsV2,
    TabelaResultado,
    GraficoResultado,
    GraficoClassificacao,
    TabelaClassificacao,
  },
  mixins: [utils],
  data() {
    return {
      disabledSelectResultado: false,
      loadingGrafico: false,
      micro_areas: [],
      micro_area: '',
      equipe: '',
      cadastros: [],
      cadastrosOriginais: [],
      dadosDoResultadoMunicipio: {
        numerador: 0,
        denominador: 0,
        resultado: 0,
      },
      dadosDoResultadoEquipe: {
        numerador: 0,
        denominador: 0,
        resultado: 0,
      },
      dadosDoResultadoMicroArea: {
        numerador: 0,
        denominador: 0,
        resultado: 0,
      },
      loading: false,
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      dataFields: {
        ...dataFields,
      },
      tabsActive: 0,
      filterSearchTable: false,
      tituloTabelaResultado: '',
      dadosDaTabelaResultado: [],
      tipoAcompanhamentoConsolidado: {
        value: 'pessoas_acompanhadas',
        label: 'Pessoas acompanhadas',
        indicador: '30',
      },
      optionsTipoAcompanhamentoConsolidado: [
        ...optionsTipoAcompanhamentoConsolidado,
      ],
      chartData: [],
      chartOptions: {
        ...chartOptions,
      },
      setRed: false,
      dadosSerieHistorica: [],
      tipoAcompanhamentoClassificacao: {
        value: 'acompanhamento-por-cadastro-esus',
        label: 'Acompanhamento por cadastro e-SUS',
        indicador: '36',
      },
      optionsTipoAcompanhamentoClassificacao: [
        ...optionsTipoAcompanhamentoClassificacao,
      ],
      dadosMunicipioClassificacao: '',
      dadosEquipeClassificacao: '',
      dadosMicroAreaClassificacao: '',
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      let response = Filter.filtro(
        this.cadastros,
        this.exibirCadastrosVermelhos,
        this.exibirCadastrosVerdes
      )
      if (response === undefined) {
        response = []
      }
      return response
    },
  },
  methods: {
    filtros(vermelho, verde) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (vermelho === true) {
        this.setRed = true
        this.exibirCadastrosVerdes = false
        this.exibirCadastrosVermelhos = true
        return
      }
      if (verde === true) {
        this.setRed = false
        this.exibirCadastrosVermelhos = false
        this.exibirCadastrosVerdes = true
        return
      }
      this.setRed = false
    },

    async onChangeTipoAcompanhamentoConsolidado(item) {
      this.tipoAcompanhamentoConsolidado = item
      this.setarResultadoMunicipio()
      this.setarResultadoEquipe()
      this.setarResultadoMicroArea()
    },

    async onChangeTipoAcompanhamentoClassificacao(item) {
      this.tipoAcompanhamentoClassificacao = item

      this.setarClassificacaoMunicipio()

      if (
        item.value == 'acompanhamento-por-cadastro-esus' ||
        item.value == 'vinculo-acompanhamento-por-cadastro-esus'
      ) {
        if (this.equipe != '') {
          this.setarClassificacaoEquipe()
        }
        if (this.micro_area != '') {
          this.setarClassificacaoMicroArea()
        }
      }

      if (
        item.value == 'acompanhamento-por-parametro-de-cadastro' ||
        item.value == 'vinculo-acompanhamento-por-parametro-de-cadastro'
      ) {
        this.dadosMunicipioClassificacao = {
          resultado: 0,
          escore: 0,
          classificacao: '-',
        }
        this.dadosMicroAreaClassificacao = {
          resultado: 0,
          escore: 0,
          classificacao: '-',
        }
        if (this.equipe != '') {
          this.setarClassificacaoEquipe()
        }
      }
    },

    setarClassificacaoMunicipio() {
      const result = Functions.resultadoClassificacaoMunicipio(
        this.tipoAcompanhamentoClassificacao,
        this.dadosDaTabelaResultado
      )
      this.dadosMunicipioClassificacao = {
        resultado: result.resultado,
        escore: result.escore,
        classificacao: result.classificacao,
        dados: result.dados,
      }
      this.$refs.graficoClassificacao.serieHistoricaMunicipio(
        this.dadosSerieHistorica,
        this.tipoAcompanhamentoClassificacao
      )
    },

    setarClassificacaoEquipe() {
      const result = Functions.resultadoClassificacaoEquipe(
        this.tipoAcompanhamentoClassificacao,
        this.dadosDaTabelaResultado,
        this.equipe.nu_ine
      )
      this.dadosEquipeClassificacao = {
        resultado: result.resultado,
        escore: result.escore,
        classificacao: result.classificacao,
        dados: result.dados,
      }
      this.$refs.graficoClassificacao.serieHistoricaEquipe(
        this.dadosSerieHistorica,
        this.tipoAcompanhamentoClassificacao,
        this.equipe
      )
    },

    setarClassificacaoMicroArea() {
      const result = Functions.resultadoClassificacaoMicroArea(
        this.tipoAcompanhamentoClassificacao,
        this.dadosDaTabelaResultado,
        this.equipe.nu_ine,
        this.micro_area
      )
      this.dadosMicroAreaClassificacao = {
        resultado: result.resultado,
        escore: result.escore,
        classificacao: result.classificacao,
        dados: result.dados,
      }
      this.$refs.graficoClassificacao.serieHistoricaMicroArea(
        this.dadosSerieHistorica,
        this.tipoAcompanhamentoClassificacao,
        this.equipe,
        this.micro_area
      )
    },

    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },

    handleExibirVermelhos(event) {
      if (event == true) {
        // mostra os vermelhos
        this.filtros(true, false)
        this.exibirCadastrosVermelhos = true
        this.exibirCadastrosVerdes = false
      } else {
        this.filtros(false, false)
        this.exibirCadastrosVermelhos = false
      }
    },

    handleExibirVerdes(event) {
      if (event == true) {
        // mostra os verdes
        this.filtros(false, true)
        this.exibirCadastrosVerdes = true
        this.exibirCadastrosVermelhos = false
      } else {
        this.filtros(false, false)
        this.exibirCadastrosVerdes = false
      }
    },

    async onChangeEquipe(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      this.dadosDoResultadoMicroArea.numerador = 0
      this.dadosDoResultadoMicroArea.denominador = 0
      this.dadosDoResultadoMicroArea.resultado = 0
      let equipe = this.$store.state.equipesV2.find((el) => {
        return el.ine_esf_eap == event.ine_esf_eap
      })
      if (equipe) {
        this.equipe = {
          nu_ine: equipe.ine_esf_eap,
          no_equipe: equipe.no_esf_eap,
          nu_cnes: equipe.nu_cnes,
        }
      }
      if (event !== null) {
        this.tipoAcompanhamentoClassificacao = {
          value: 'acompanhamento-por-cadastro-esus',
          label: 'Acompanhamento por cadastro e-SUS',
          indicador: '36',
        }
        this.tabsActive = 0
        this.micro_area = ''
        this.cadastros = []
        this.cadastrosOriginais = []
        try {
          this.loading = true
          this.buscarCadastrosPorEquipe()
        } catch (error) {
          console.log(error)
        }
      } else {
        this.dadosDoResultadoEquipe.numerador = 0
        this.dadosDoResultadoEquipe.denominador = 0
        this.dadosDoResultadoEquipe.resultado = 0
        this.cadastros = []
        this.cadastrosOriginais = []
        this.micro_area = ''
        this.equipe = ''
        this.dadosEquipeClassificacao = ''
        this.dadosMicroAreaClassificacao = ''
      }
      this.setarClassificacaoMunicipio()
      this.setarResultadoEquipe()
      this.setarClassificacaoEquipe()
    },

    setarResultadoMunicipio() {
      const result = Functions.resultadoDoMunicipio(
        this.tipoAcompanhamentoConsolidado,
        this.dadosDaTabelaResultado
      )
      this.dadosDoResultadoMunicipio.numerador = result.numerador
      this.dadosDoResultadoMunicipio.denominador = result.denominador
      this.dadosDoResultadoMunicipio.resultado = result.resultado
      this.$refs.graficoResultado.serieHistoricaMunicipio(
        this.dadosSerieHistorica,
        this.tipoAcompanhamentoConsolidado
      )
    },

    setarResultadoEquipe() {
      const result = Functions.resultadoDaEquipe(
        this.tipoAcompanhamentoConsolidado,
        this.dadosDaTabelaResultado,
        this.equipe.nu_ine
      )
      this.dadosDoResultadoEquipe.numerador = result.numerador
      this.dadosDoResultadoEquipe.denominador = result.denominador
      this.dadosDoResultadoEquipe.resultado = result.resultado
      this.$refs.graficoResultado.serieHistoricaEquipe(
        this.dadosSerieHistorica,
        this.tipoAcompanhamentoConsolidado,
        this.equipe
      )
    },

    async setarResultadoMicroArea() {
      if (this.micro_area != '') {
        const result = Functions.resultadoDaMicroArea(
          this.tipoAcompanhamentoConsolidado,
          this.dadosDaTabelaResultado,
          this.equipe.nu_ine,
          this.micro_area
        )
        this.dadosDoResultadoMicroArea.numerador = result.numerador
        this.dadosDoResultadoMicroArea.denominador = result.denominador
        this.dadosDoResultadoMicroArea.resultado = result.resultado
        this.$refs.graficoResultado.serieHistoricaMicroArea(
          this.dadosSerieHistorica,
          this.tipoAcompanhamentoConsolidado,
          this.equipe,
          this.micro_area
        )
      }
    },

    async onChangeMicroArea(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      this.tabsActive = 0
      this.dadosDoResultadoMicroArea.numerador = 0
      this.dadosDoResultadoMicroArea.denominador = 0
      this.dadosDoResultadoMicroArea.resultado = 0
      this.micro_area = event?.micro_area
      if (event !== null) {
        this.situacao = ''
        this.loading = true
        this.disabledSelectResultado = true
        this.tipoAcompanhamentoClassificacao = {
          value: 'acompanhamento-por-cadastro-esus',
          label: 'Acompanhamento por cadastro e-SUS',
          indicador: '36',
        }
        if (this.micro_area !== undefined) {
          let response = await Functions.getCadastrosPorMicroArea(
            this.$store.state.cod_ibge,
            this.equipe.nu_ine,
            this.micro_area
          )
          if (response) {
            this.cadastros = response
            this.cadastrosOriginais = response
            this.setRed = true
            this.filtros(true, false)
            this.loading = false
          }
        }
      } else {
        // cadastros por equipe
        this.buscarCadastrosPorEquipe()
        this.micro_area = ''
        this.cadastros = []
        this.cadastrosOriginais = []
        this.disabledSelectResultado = false
        this.dadosMicroAreaClassificacao = ''
        this.onChangeEquipe(this.equipe)
      }
      this.setarClassificacaoMunicipio()
      this.setarClassificacaoEquipe()
      this.setarResultadoMicroArea()
      this.setarClassificacaoMicroArea()
    },

    async buscarDadosIniciais() {
      try {
        // dados da série histórica
        let response2 = await this.$api.get(
          `/app/v2/serie-historica/${this.$store.state.cod_ibge}/indicador/[30,36,37,55,56]`
        )
        this.dadosDaTabelaResultado = response2.data
        this.dadosSerieHistorica = response2.data
        // dados do município
        this.setarResultadoMunicipio()
        this.setarClassificacaoMunicipio()
        this.loading = false
      } catch (error) {
        console.log(error)
      }
    },

    async buscarCadastrosPorEquipe() {
      this.loading = true
      let response = await Functions.getCadastrosPorEquipe(
        this.$store.state.cod_ibge,
        this.equipe.nu_ine
      )
      if (response) {
        this.cadastros = response
        this.cadastrosOriginais = response
        this.setRed = true
        this.filtros(true, false)
        this.loading = false
      }
    },

    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.equipe,
        this.micro_area
      )
    },

    init() {
      this.buscarDadosIniciais()
    },
  },
  created() {
    this.init()
  },
}
</script>

<style src="./styles.scss" scoped lang="scss" />
